import { useState } from "react";
import { Dialog, DialogTrigger, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { CandidateSelector } from "@/components/candidates/CandidateSelector";
import { toast } from "@/hooks/use-toast";
import { useTranslation } from "react-i18next";

interface AddCandidateDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onAddCandidate: (candidateId: string) => void;
}

export const AddCandidateDialog = ({ isOpen, onClose, onAddCandidate }: AddCandidateDialogProps) => {
  const { t } = useTranslation();
  const [selectedCandidate, setSelectedCandidate] = useState<any | null>(null);
  
  const handleSelectCandidate = (candidate: any) => {
    setSelectedCandidate(candidate);
  };

  const handleAddCandidate = () => {
    if (!selectedCandidate) {
      toast({
        title: t("errors.error"),
        description: t("jobs.kanban.selectCandidateRequired"),
        variant: "destructive"
      });
      return;
    }
    
    onAddCandidate(selectedCandidate.id);
    
    // Reset form
    setSelectedCandidate(null);
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("jobs.kanban.addCandidateToProcess")}</DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="candidate">{t("jobs.kanban.selectCandidate")}</Label>
            <CandidateSelector 
              onSelectCandidate={handleSelectCandidate}
              buttonClassName="w-full"
            />
          </div>
          
          <div className="space-y-2">
            <Label htmlFor="stage">{t("jobs.kanban.initialStage")}</Label>
            <p className="text-sm text-gray-500">{t("jobs.kanban.addedToAppliedStage")}</p>
          </div>
        </div>
        
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>{t("common.cancel")}</Button>
          <Button onClick={handleAddCandidate}>{t("jobs.kanban.addCandidate")}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
